/**
 * ReasonModal — asks why the driver didn't collect the frame, as a list of rows to tap.
 * Replaces the reason step of $scope.collectFrame in RunCtrl.
 */

import { useState } from 'react';
import { Button, Text, UnstyledButton } from '@mantine/core';
import { IconCheck } from '@tabler/icons-react';
import { ModalFrame } from './ModalFrame';

const REASONS = [
  'Gates Locked',
  'Car Blocking Access',
  'Could Not Find Bag',
  'Too Heavy',
  'Overfilled',
  'No Street Access',
  'Customer Wants to Keep Service',
  'Other / Notes',
];

interface Props {
  opened: boolean;
  onConfirm: (reason: string) => void;
  onClose: () => void;
}

export function ReasonModal({ opened, onConfirm, onClose }: Props) {
  const [reason, setReason] = useState<string | null>(null);
  const [wasOpened, setWasOpened] = useState(opened);

  // The modal stays mounted, so each stop starts with no reason chosen
  if (opened !== wasOpened) {
    setWasOpened(opened);
    if (opened) setReason(null);
  }

  return (
    <ModalFrame
      opened={opened}
      onClose={onClose}
      title="Reason for Not Collecting Frame"
      actions={
        <>
          <Button variant="default" onClick={onClose}>
            Cancel
          </Button>
          <Button color="blue" disabled={!reason} onClick={() => reason && onConfirm(reason)}>
            Continue
          </Button>
        </>
      }
    >
      {REASONS.map(option => {
        const selected = option === reason;
        return (
          <UnstyledButton
            key={option}
            aria-pressed={selected}
            onClick={() => setReason(option)}
            w="100%"
            mih={50}
            px="sm"
            bg={selected ? 'blue.0' : undefined}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              borderBottom: '1px solid var(--mantine-color-gray-2)',
            }}
          >
            <Text>{option}</Text>
            {selected && <IconCheck size={20} color="var(--mantine-color-blue-6)" />}
          </UnstyledButton>
        );
      })}
    </ModalFrame>
  );
}
